export * from './constants.base';

export const ENABLE_AUTO_SHOW_REGION_SELECTOR = true;
export const ENABLE_IDENTITY_SYNC_ON_LOGIN = true;
export const ENABLE_NO_PIN_CHECK_PREPAID_MERGE = true;
